import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as moment from 'moment';
import Spinner from "web/components/Spinner";
import Layout from "web/components/Layout";
import AlertModal from "web/components/AlertModal";
import styled from "styled-components";
import { getTermsAndConditionsApi, getTermsAndConditionsAcknowledgeDetails } from "redux/actions/auth";
import { Helmet } from "react-helmet";
const OpertaionalTC = () => {
  const [pageContent, setPageContent] = useState()
  const [tnCDetails, setTnCDetails] = useState()
  const dispatch = useDispatch();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  // const latestTermsAndCondition = useSelector(state => state.authReducer.latestTermsAndCondition)

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  let title = "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // if (latestTermsAndCondition) setPageContent(latestTermsAndCondition)
    // else fetchPageContent()
    fetchPageContent()
    fetchTnCDetails()
  }, [])

  const fetchPageContent = async () => {
    let accountType = localStorage.getItem('accountType')
    let userRole = ''
    if (accountType === 'Guest') {
      userRole = 'GUEST'
    } else {
      userRole = 'MEMBER'
    }
    let response = await dispatch(getTermsAndConditionsApi({ token, userRole }))
    if (response.content) {
      setPageContent(response)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      }
    }
  }

  const fetchTnCDetails = async () => {
    let email = localStorage.getItem('email')
    let termsDetails = await dispatch(getTermsAndConditionsAcknowledgeDetails(email, token))
    if (termsDetails.status === 'SUCCESS') {
      setTnCDetails(termsDetails.payload)
    } else {
      if (termsDetails.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      }
    }
  }

  const createMarkupForPageContent = () => {
    if (pageContent) return { __html: pageContent.content }
  }

  return (
    <>
      <Helmet title="Operational Terms and Conditions for Pallet Buyers and Sellers | PalletTrader" >
        <meta name="description"
          content="Learn more about  the operational terms and conditions of our marketplace. Understand the policies and guidelines for a smooth and secure buying and selling experience." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/operational-terms-and-conditions" />
      </Helmet>
      <Layout pageType="operational" topBarViewMobile={"hide"}>
        {loaderVisible && <Spinner />}
        <Container>
          <h3>Operational T&Cs</h3>
          <p>Version : {tnCDetails?.termsAndConditionsVersion}</p>
          <p>Acknowledged Date : {(tnCDetails && tnCDetails.termsAndConditionsApplyTime) ? moment(tnCDetails.termsAndConditionsApplyTime).format("MMMM D, YYYY") : ''}</p>
          <TermText>
            <div dangerouslySetInnerHTML={createMarkupForPageContent()} />
          </TermText>
        </Container>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          content=''
          link=''
          callBackAlert={(val) => { }}
        />
      </Layout>
    </>
  );
};

export default OpertaionalTC;

const Container = styled.div`
  max-width: 1423px;
  padding: 50px 10px;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding: 15px;
  }
  h3 {
    font-family: "latobold";
    text-align: center;
  }
`;
const TermText = styled.div`
  padding: 15px 0;
  margin-top: 15px;
  p {
    text-align: justify;
  }
`;
